export interface ITableSort {
    // this is a flag for the order direction. true = ascending
    categoryText: boolean;
    // this is a flag for the order direction. true = ascending
    intSequence: boolean;

    thirdKeyAsc?: boolean;
    thirdKey?: string;
}

export enum EDefaultTableSortingKeys {
    intSequence  = 'intSequence',
    categoryText = 'categoryText',
}

export const sortOptions = (
    array: any[],
    sortObject: ITableSort,
) => {
    const {intSequence = true, categoryText = true, thirdKeyAsc, thirdKey}: ITableSort = sortObject;
    const firstKeyUnit = categoryText ? -1 : 1;
    const secondKeyUnit =  intSequence ? -1 : 1;
    const thirdKeyUnit = thirdKeyAsc ? -1 : 1;
    
    return array.sort((firstItem, secondItem) => {
       
        if (firstItem.categoryText.proMTSequence < secondItem.categoryText.proMTSequence) {
            return firstKeyUnit;
        }
        if (firstItem.categoryText.proMTSequence > secondItem.categoryText.proMTSequence) {
            return -firstKeyUnit;
        }

        if (firstItem.intSequence < secondItem.intSequence) {
            return secondKeyUnit;
        }
        if (firstItem.intSequence > secondItem.intSequence) {
            return -secondKeyUnit;
        }

        if(thirdKey) {
            if(firstItem[thirdKey] < secondItem[thirdKey]) {
                return thirdKeyUnit;
            }
            if(firstItem[thirdKey] > secondItem[thirdKey]) {
                return -thirdKeyUnit;
            }
        }

        return 0;
    });
};



// WEBPACK FOOTER //
// ./src/utils/SortUtils.ts